export const MAC_COLUMN = "Mac address";
export const DURATION_COLUMN = "Duración";
export const OS_COLUMN = "Dispositivo";